import React from 'react';

export default props => (
  <section className='content-header flex-wrap'>
    <h1>{props.title} <small>{props.small}</small></h1>
  </section>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/content/ContentHeader.jsx